/**
 * True for the backoffice hub and every page under it, with or without a locale prefix
 * (`/backoffice`, `/en/backoffice`, `/fi/backoffice/dashboard`). Anchored to the start
 * of the path so `/en/company/backoffice` (a slug) is not caught, and deliberately not
 * `/backoffice-access-denied`: that page is outside the backoffice and keeps the normal site chrome.
 */
export function isBackofficePathname(pathname: string | null | undefined): boolean {
  return /^(\/(en|fi|sv))?\/backoffice(\/|$)/.test(String(pathname ?? '').split(/[?#]/)[0]);
}
